var React = require('react');

function Arrowright (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.2531 4.7002L22.2154 8.99978L18.2531 13.2994","stroke":"#333333","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 9L21.8889 9","stroke":"#333333","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Arrowright.defaultProps = {"width":"25","height":"18","viewBox":"0 0 25 18","fill":"none"};

module.exports = Arrowright;

Arrowright.default = Arrowright;
